import styled from 'styled-components';

export const MobileDeviceFrame = styled.div<{ $width?: string; $maxWidth?: string }>`
  position: relative;
  width: ${({ $width }) => $width ?? '100%'};
  max-width: ${({ $maxWidth }) => $maxWidth ?? '375px'};
  aspect-ratio: 9 / 19.5;
  max-height: min(80vh, 700px);
  background: ${({ theme }) => theme.designToken.neutral900};
  border-radius: 36px;
  box-shadow: 0 0 0 5px #000, 0 24px 48px rgba(0, 0, 0, 0.35), inset 0 0 0 1px rgba(255, 255, 255, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

export const MobileDeviceNotch = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 28px;
  background: ${({ theme }) => theme.designToken.neutral900};
  border-radius: 0 0 20px 20px;
  z-index: 2;
  flex-shrink: 0;
`;

export const MobileStatusBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0 24px;
  padding-top: env(safe-area-inset-top, 12px);
  flex-shrink: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
  background: ${({ theme }) => theme.vars.newColor.white};
  z-index: 1;
`;

export const MessagingBackground = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: ${({ theme }) => theme.vars.newColor.lightGS2};
  display: flex;
  flex-direction: column;
  padding: 12px 12px 24px;
  padding-bottom: max(24px, env(safe-area-inset-bottom));
`;
